import { takeLatest, put, race, take } from 'redux-saga/effects';

import { shareToChatModalActions } from './share-to-chat-modal';
import * as shareToChat from './share-to-chat-req';
import * as error from '../../ui/error';

function* handleShareToChatWorker({
  payload: { userId, documentUid, channelName, roomId },
}) {
  yield put(
    shareToChat.actions.send({
      userId,
      document_uid: documentUid,
      roomId,
      channelName,
    }),
  );

  const { succeedShareToChat } = yield race({
    succeedShareToChat: take(shareToChat.consts.SUCCEED),
    rejectedShareToChat: take(shareToChat.consts.REJECTED),
  });
  yield put(shareToChatModalActions.close());
  if (succeedShareToChat) {
    yield put({
      type: shareToChat.consts.SUCCEED,
      values: { recipient: channelName },
    });
  } else {
    yield put({
      type: error.consts.UPDATE,
      payload: { id: 'errors.common' },
    });
  }
}

export default function* handleShareToChatSaga() {
  yield takeLatest(shareToChat.actions.init, handleShareToChatWorker);
}



// WEBPACK FOOTER //
// ./src/redux/healthboard/patientPortal/share-to-chat-saga.js